module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.23.0@babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 649
 ** module chunks = 0 1
 **/